import "./index.css"
import { CircleLoader } from '../Loader'
import { FaShare, FaUsers, FaUserSlash } from 'react-icons/fa'
import { Modal, Table } from 'antd'
import { useNotification } from 'src/hooks/useNotification'
import { User } from '../ReportTableManage/index.type'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import ShareReportSearchResults from './ShareReportSearchResults'
import ShareReportsTableColumn from './ShareReportsTableColumn'
import TextInputWithSearchIcon from '../input/TextInputWithSearchIcon'
import useCallApi from 'src/hooks/useCallApi'
import { Parm_Who_Need_Help_With} from "./index.type"
import { useAccount, useMsal } from '@azure/msal-react'
import { useGetId } from 'src/hooks/useGetOid'
import { Tooltip } from 'react-tooltip'

function ShareReport({ reportId, powerBIReportId }: { reportId: string, powerBIReportId: string | undefined })
{
    const { t } = useTranslation();
    const { accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const { getOid } = useGetId();
    const { callApiLoading, callApi, isError, data, setData } = useCallApi()
    const { notification, contextHolder } = useNotification();
    const [searchUserInputValue, setSearchUserInputValue] = useState('')
    const [searchQuery, setSearchQuery] = useState('')
    const [showResults, setShowResults] = useState(false)
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [listOfTable, setListOfTable] = useState<User[] | []>([])


    const handleSearch = async (event: React.ChangeEvent<HTMLInputElement>) =>
    {
        setSearchUserInputValue(event.target.value)
        setSearchQuery(event.target.value)
        setShowResults(true)
    }
    const handleReset = async () =>
    {
        setSearchUserInputValue('')
        setSearchQuery('')
        setShowResults(false)
    }
    const handleShare = async () =>
    {
        if (listOfTable.length === 0)
        {
            notification({ content: { name: "Empty list", message: t("reports.requestAccess.noUsersSelectedForsharing") }, type: 'error' })
            return
        }

        //v Get the oid of the user who is sharing the report to pass it as a parameter to the API
        const oid = await getOid();
        if (!oid)
        {
            //vs notification({ content: { name: t("t2"), message: t("reports.requestAccess.loginUserInformationNotAvailable") }, type: 'error' })
            return
        }

        if (powerBIReportId === undefined)
        {
            //notification({ content: { name: t("t2"), message: t("reports.requestAccess.reportInformationNotAvailable") }, type: 'error' })
            //console.log("PowerBIReportId is undefined", powerBIReportId)
            return
        }


        //v Prepare the list of userObjectIds to pass it as a parameter to the API (the API expects a comma separated string of userObjectIds)        
        var PARM_WHO_NEED_ACCES_USEROBJECTIDS: string[] = listOfTable.map(user => user.userObjectId).join(',').toString().split(',');
        // console.log('PARM_WHO_NEED_ACCES', PARM_WHO_NEED_ACCES_USEROBJECTIDS);
        // console.log("reportId", reportId);
        // console.log("oid", oid);
        const body: { reportId: string; submittedByUserId: string; userIds: string[] } = {
            reportId: reportId,
            submittedByUserId: oid,
            userIds: PARM_WHO_NEED_ACCES_USEROBJECTIDS
        }
        //console.log('RequestAccess API BODY', body);

        //v call the endpoint RequestAccess with the list of users to share with (listOfTable) and the reportId as body parameters
        let res: any = await callApi({
            endpoint: "RequestAccess",
            method: 'POST',
            body
        });
        //console.log('RequestAccess API response', res);

        if (res?.status === 200)
        {
            //notification({ content: { name: t("t2"), message: t("reports.requestAccess.requestAccessUsersAddedToAudit") }, type: 'success' });
        } else
        {
            //notification({ content: { name: t("t2"), message: `${t("reports.requestAccess.errorRequestAccessUsersAddedToAudit")}: ${res.status || 'API Error'}` }, type: 'error' });
            return;
        }

        const PARM_WHO_NEED_ACCES = listOfTable.map(user => user.email).join(',')
        //console.log("PowerBIReportId", powerBIReportId, "reportId", reportId)
        //url = `${process.env.REACT_APP_API_VALIDATE_USERS_ACCESS}?${query}` //api/user/validateuseraccess
        // read value from .env.development.local
        const serviceNow_base_URL: string = `${process.env.REACT_APP_SERVICENOW_BASEURL}`;
        //console.log('SERVICENOW_BASE_URL: ', serviceNow_base_URL)
        if (!serviceNow_base_URL)
        {
            //console.error('ServiceNow base URL is not defined');            
            return;
        }

        const serviceNowUrl = `${serviceNow_base_URL}&parm_need_help_with=${Parm_Who_Need_Help_With.REQUEST_ACCESS_TO_REPORT}&parm_selected_report=${reportId}&parm_who_need_access=${PARM_WHO_NEED_ACCES}&parm_FromInsightHub=true`
        //console.log('serviceNowUrl', serviceNowUrl)
        window.open(serviceNowUrl, '_blank');
        setModalIsOpen(false)
        handleReset()
        setListOfTable([])
    }

    return (
        <>
            <FaShare
                onClick={() => setModalIsOpen(!modalIsOpen)}
                className='cursor-pointer text-[#857f7f] hover:text-red-500'
                data-tooltip-id="share-report-tooltip"
                data-tooltip-content={t("reports.requestAccess.requestAccess")}
            />
            <Tooltip
                id="share-report-tooltip"
                place="top"
                className="requestAccess"
            />
            <Modal
                className='shareReport'
                centered
                width={'clamp(560px, 50vw, 1100px)'}
                styles={{ body: { maxHeight: '65vh', overflowY: 'auto' } }}
                title={
                    <div className='flex items-center gap-3'>
                        <span className='text-[18px]'>{t("reports.requestAccess.requestAccessToReport")}</span>
                        <FaUsers
                            size={20}
                            data-tooltip-id="add-users-tooltip"
                            data-tooltip-content={t("reports.requestAccess.placeholderSearch")}
                        />
                        <Tooltip
                            id="add-users-tooltip"
                            place="top"
                            className="addUserTooltip"
                        />
                    </div>
                }
                okText={t("reports.requestAccess.requestAccess")}
                cancelText={t("reports.requestAccess.cancel")}
                open={modalIsOpen}
                onOk={handleShare}
                onCancel={() => { handleReset(); setModalIsOpen(false); setListOfTable([]) }}

            >
                <div className='w-full flex flex-col gap-5 '>
                    <div className='relative w-full'>
                        <TextInputWithSearchIcon
                            handleChange={(event) => handleSearch(event)}
                            placeholder={t('reports.requestAccess.placeholderSearch')}
                            value={searchUserInputValue}
                        />
                        {showResults &&
                            <ShareReportSearchResults
                                searchQuery={searchQuery}
                                setShowResults={setShowResults}
                                setListOfTable={setListOfTable}
                                listOfTable={listOfTable}
                                handleReset={handleReset}
                                reportId={reportId}
                            />
                        }
                    </div>
                    <h2 className='font-semibold'>{t('reportManagement.userAndGroups.accessRequestUsers')}</h2>
                    <Table
                        columns={ShareReportsTableColumn({ setListOfTable, listOfTable })}
                        loading={{ indicator: <div><CircleLoader /></div>, spinning: callApiLoading }}
                        dataSource={listOfTable}
                        className='w-full'
                        rowKey={(record: User) => record.email || record.userObjectId}
                        showSorterTooltip={false}
                        pagination={false}
                        scroll={{ y: 350 }}
                        locale={{
                            emptyText()
                            {
                                return <div className='flex justify-center items-center flex-col h-[250px]'><FaUserSlash size={40} /><h2>{t("reports.requestAccess.noUsersSelectedForsharing")}</h2></div>
                            },
                        }}
                    />
                </div>
                {contextHolder}
            </Modal>
        </>
    )
}

export default ShareReport